<template>
  <div id="app">
    <!--引入头部-->
    <TheHeader></TheHeader>
    <!--路由占位符-->
    <router-view></router-view>
    <!--引入底部-->
    <TheFooter></TheFooter>
  </div>
</template>

<script>
import TheHeader from "./components/layouts/TheHeader";
import TheFooter from "./components/layouts/TheFooter";

export default {
  name: 'app',
  components: {
    TheFooter,
    TheHeader,
  },
  head: {
    titleTemplate(title) {
      title = typeof title === "function" ? title(this.$store) : title;
      return title ? `${title} - 清瀚致远教育` : '清瀚致远教育';
    }
  },
}
</script>

<style>
@import "static/css/main.scss";
</style>
